(() => {
  function start(page) {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    const find = selector => page.querySelector(selector);
    const qty = find('[name="quantity"]');
    const add = find('[data-crfl-add]');
    const variants = JSON.parse(find('[data-crfl-variants]').textContent);
    let variant = variants[find('[name="id"]').value];
    let member = null;
    let status = 'regular';
    let view = null;
    let cartRevision = 0;
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: page.dataset.currency || 'USD' }).format(cents / 100);
    function render() {
      const quantity = Number(qty.value);
      const validQuantity = Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 50;
      find('[data-crfl-quantity-error]').hidden = validQuantity;
      const quoted = status === 'quoted' && view;
      const memberPriced = quoted && view.memberCents !== null;
      find('[data-crfl-premium]').hidden = !member;
      find('[data-crfl-visitor]').hidden = !!member || !variant.hasMember;
      find('[data-crfl-visitor-price]').textContent = variant.memberText + ' for members';
      find('[data-crfl-was]').hidden = !memberPriced;
      find('[data-crfl-was]').textContent = money(quoted ? view.retailCents : variant.price);
      find('[data-crfl-now]').textContent = money(memberPriced ? view.memberCents : quoted ? view.retailCents : variant.price);
      find('[data-crfl-member-label]').hidden = !memberPriced;
      const per = find('[data-crfl-per]');
      per.hidden = variant.rolls <= 1;
      per.textContent = money((memberPriced ? view.memberCents : variant.price) / variant.rolls) + ' per roll';
      const line = find('[data-crfl-member-line]');
      line.hidden = !member;
      line.textContent = quoted ? view.caption : status === 'loading' ? 'Checking member price.' : 'Member price is unavailable right now.';
      const waiting = member && !quoted;
      add.disabled = !variant.available || !validQuantity || !!waiting;
      add.textContent = !variant.available ? 'Sold Out' : waiting ? 'Checking Member Price' : 'Add to Cart' + (validQuantity ? ' · ' + money(quoted ? view.totalCents : variant.price * quantity) : '');
      if (member && status === 'unavailable' && variant.available) add.textContent = 'Member Price Unavailable';
      find('[data-crfl-minus]').disabled = !validQuantity || quantity <= 1;
      find('[data-crfl-plus]').disabled = !variant.available || !validQuantity || quantity >= 50;
      find('[data-crfl-sold]').hidden = variant.available;
      page.querySelectorAll('[data-crfl-card-price]').forEach(card => {
        const price = card.querySelector('[data-crfl-card-member]');
        const eligible = !!member && !!price && member.rollsLeft >= Number(card.dataset.rolls);
        card.querySelector('[data-crfl-card-was]').hidden = !eligible;
        card.querySelector('[data-crfl-card-retail]').hidden = eligible;
        if (price) price.hidden = !eligible;
      });
    }
    page.addEventListener('crfl:film:quote', event => {
      if (page.dataset.memberPrices === 'false') return;
      status = event.detail.status;
      if (status === 'regular') member = null;
      else if (event.detail.member) member = event.detail.member;
      view = event.detail.view || null;
      render();
    });
    const form = find('form[action*="/cart/add"]');
    const productForm = form.closest('product-form');
    form.addEventListener('submit', () => {
      ++cartRevision;
      find('[data-crfl-cart-status]').hidden = true;
    });
    const confirmCart = async event => {
      if (event.target !== productForm) return;
      const current = ++cartRevision;
      const selected = find('[name="id"]').value;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (current !== cartRevision || selected !== find('[name="id"]').value) return;
        const lines = cart.items.filter(item => String(item.variant_id) === selected);
        const count = lines.reduce((sum, item) => sum + item.quantity, 0);
        const total = lines.reduce((sum, item) => sum + item.final_line_price, 0);
        const unit = variant.rolls > 1 ? 'pack' : 'roll';
        const confirmed = find('[data-crfl-cart-status]');
        confirmed.textContent = count ? 'Your cart has ' + count + ' ' + unit + (count === 1 ? '' : 's') + ' of this film · ' + money(total) + '.' : 'This film is not in your cart.';
        confirmed.hidden = false;
      } catch {}
    };
    page.addEventListener('on:cart:add', confirmCart);
    page.addEventListener('on:cart:error', confirmCart);
    const updateQuantity = delta => {
      qty.value = String(Math.max(1, Math.min(50, (Number(qty.value) || 1) + delta)));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    };
    find('[data-crfl-minus]').addEventListener('click', () => updateQuantity(-1));
    find('[data-crfl-plus]').addEventListener('click', () => updateQuantity(1));
    page.addEventListener('input', event => { if (event.target === qty) { view = null; status = 'loading'; render(); } });
    page.addEventListener('change', event => {
      if (event.target.name === 'id') {
        ++cartRevision;
        find('[data-crfl-cart-status]').hidden = true;
        variant = variants[event.target.value];
        page.dataset.rolls = variant.rolls;
      }
      if (event.target.name === 'id' || event.target === qty) { view = null; status = 'loading'; render(); }
    });
    page.querySelectorAll('[data-crfl-thumb]').forEach(button => button.addEventListener('click', () => {
      page.querySelectorAll('[data-crfl-photo]').forEach(photo => { photo.hidden = photo.dataset.crflPhoto !== button.dataset.crflThumb; });
      page.querySelectorAll('[data-crfl-thumb]').forEach(thumb => {
        const selected = thumb === button;
        thumb.setAttribute('aria-pressed', String(selected)); thumb.classList.toggle('is-on', selected);
      });
    }));
    const header = document.querySelector('#shopify-section-header, #pageheader');
    if (header) new ResizeObserver(() => page.style.setProperty('--crfl-header-height', header.getBoundingClientRect().height + 'px')).observe(header);
    render();
  }
  document.querySelectorAll('[data-crfl-film-stock]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-crfl-film-stock]').forEach(start));
})();
